import { useTranslation } from "@nova/use-translation"

export const AuthenticationErrorMessage = ({ message }: { message: string }) => {
    const { t } = useTranslation()
    return <div className="text-red-500 text-[18px] leading-[24px]">{t(message)}</div>
}
